<template>
  <div>
    <FormulateInput
      :label="translate('header.language')"
      :value="getCurrentLang"
      @change="handleChange"
      :options="langs"
      type="select"
      placeholder="Select an language"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      langs: [
        {
          label: "🇪🇸 Español",
          value: "es",
        },
        {
          label: "🇺🇸 English",
          value: "en",
        },
      ],
    };
  },
  methods: {
    ...mapActions(["changeLanguage"]),
    handleChange(lang) {
      this.changeLanguage(lang.target.value);
    },
  },
  computed: {
    ...mapState(["currentLanguage"]),
    getCurrentLang() {
      return this.currentLanguage;
    },
  },
};
</script>

<style>
</style>